export const COLLECTION_NAME_MAX_LENGTH = 100;
